import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

interface IWebEngageEvent {
  event_data: object;
  event_name: string;
  user_id: number;
  type: string;
  user?: object;
}

export const updateEventLog = (eventLog: any) =>
  axiosInstance.request({
    baseURL: gatewayUrl,
    url: `events/log-event`,
    method: "post",
    data: eventLog,
  });

export const logWebEngageEvent = async ({event_data, event_name, user_id, type, user}: IWebEngageEvent) => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: "events/log-event",
    method: "POST",
    data: {
      event_data,
      event_name,
      user_id: user_id,
      user,
      type,
    },
  });
  return res;
};
